import Base from './base'
import renderFields from './webview-script.pug'

export default class WebviewScript extends Base
  @label: "網頁腳本觸發"

  renderFields: renderFields
